// Con qué parámetro se busca un aviso por su referencia en el search-service.
// En FincaRaíz la ficha muestra el id del aviso como su código, y el `codigo` de muchos
// avisos es otro (el del Fincaraíz viejo), así que en CO la referencia se busca por id
// (INF-2344). El search-service tipa `id` como entero: lo que no es un número no se
// busca por referencia, y un id de puros ceros tampoco, porque lo toma como «sin id» y
// devuelve un aviso cualquiera.
export const referenceSearchParams = (
	value: string,
	countryCode: string
): { code: string } | { id: string } | null => {
	if (countryCode !== "CO") return { code: value };

	const id = value.trim();
	return /^0*[1-9]\d*$/.test(id) ? { id } : null;
};
